import { Injectable, InjectionToken, Inject } from '@angular/core';
import { IRxStorage } from '@rxjs-storage/core/dist/types/internal/interfaces';
import {
  availableLanguages,
  defaultLanguage,
  en,
  pt,
  TranslationsInterface,
} from 'translations';
import { AppConfigService } from './app-config.service';

export const TRANSLATION_STORAGE = new InjectionToken<IRxStorage>(
  'TRANSLATION_STORAGE'
);

const translationInfoKey = 'translation:info';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  currLangCode = defaultLanguage.code;
  currLang: TranslationsInterface = defaultLanguage.value;

  constructor(
    @Inject(TRANSLATION_STORAGE) private storage: IRxStorage,
    public appConfig: AppConfigService
  ) {
    const presetLangCode: string = this.storage.getItem(translationInfoKey);
    this.currLangCode = presetLangCode ? presetLangCode : defaultLanguage.code;

    if (this.currLangCode === availableLanguages.pt) {
      this.currLang = pt;
    }

    if (this.currLangCode === availableLanguages.en) {
      this.currLang = en;
    }
  }

  getCurrentLanguageCode() {
    if (this.appConfig.externalMode) {
      return this.currLangCode;
    }

    return defaultLanguage.code;
  }

  getCurrentLanguage() {
    if (this.appConfig.externalMode) {
      return this.currLang;
    }

    return defaultLanguage.value;
  }

  setCurrentLanguage(languageCode: string) {
    this.currLangCode = languageCode;
    this.storage.setItem(translationInfoKey, languageCode);

    if (languageCode === availableLanguages.pt) {
      this.currLang = pt;
    }

    if (languageCode === availableLanguages.en) {
      this.currLang = en;
    }
  }
}
